import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import {  Response, Headers, RequestMethod, ResponseContentType } from '@angular/http';
//import { environment } from '../../../../environments/environment';
//import { Logger } from '../../../core/logger/logger.service';

import { Subject } from 'rxjs';

import 'rxjs/add/operator/map';
import { Client, Idencrypt } from '../entity/exhibitor';
import { Contact } from '../entity/Contact';
import { Pjoint } from '../entity/Pjoint';
import { Prospect } from '../entity/prospect';
import { Stand } from '../entity/Stand';
import { Facture } from '../entity/Facture';
import { environment } from 'src/environments/environment';
import { AppSettings } from './app.setting';
import { FilterClient } from '../entity/Filter';
import { Anonyme } from '../entity/Anonyme';
import { VisaFormTbl } from '../entity/VisaFormTbl';
import { Staff } from '../entity/Staff';





const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const httpPdfOptions = {
    responseType: 'blob' as 'json',
    headers: new HttpHeaders({
        'Accept': 'application/pdf',
        'Content-Type': 'application/pdf'
    })
};
@Injectable()
export class ExhibitorService {
   

    private baseUrl = environment.restApi;
    // private baseUrlOnline = environment.restApiOnline;
    private exhibitorsUrl = `${this.baseUrl}participants`;
    private exhibitorsUrlERP = `${environment.restApiERP}participants`;
     

    // private onlineformtblUrl = `${this.baseUrlOnline}visaformtbl`;
    private idencryptUrl = `${this.baseUrl}idencrypt`;
    constructor(

      
        private http: HttpClient,
    ) {
    }

    /** 
     * GET: get all exhibitors from the database 
     */
    getExhibitors(): Observable<any> {

        return this.http
            .get<Client[]>(this.exhibitorsUrl)
            .pipe(
                tap(_ => this.notify('fetched exhibitors', 'GET')),
                catchError(this.handleError('getClients', 'GET'))
            );
    }


    addClient(type:string,raisonSocial:string): Observable<Client> {
        let idProjet = 1;
        let user=JSON.parse(localStorage.getItem("currentUser"))
        user.tempstring=raisonSocial;
                return this.http.put<Client>(`${this.exhibitorsUrl}/addClient/${idProjet}/${type}`,user);
    }



    getEnCryptClient(idClient: number): Observable<Idencrypt> {

        let idClientDecal = idClient + AppSettings.DECAL_EXPO;
        return this.http
            .get<Idencrypt>(this.idencryptUrl + "/" + idClientDecal)
            .pipe(
                tap(_ => this.notify('fetched exhibitors', 'GET')),
                catchError(this.handleError('getClients', 'GET'))
            );
    }



    findByUser(userId: number): Observable<Client[]> {

        return this.http
            .get<Client[]>(this.exhibitorsUrl + '/findByUser/' + userId)
            .pipe(
                tap(_ => this.notify('fetched exhibitors', 'GET')),
                catchError(this.handleError('getClients', 'GET'))
            );
    }

    filterClientsAnonyme(filterClient: FilterClient): Observable<Anonyme[]> {
 
        return this.http
            .put<Client[]>(this.exhibitorsUrl + '/filterClientsAnonyme/', filterClient,httpOptions)
            .pipe(
                tap(_ => this.notify('fetched exhibitors', 'GET')),
                catchError(this.handleError('getClients', 'GET'))
            );
    }

    findAllExhibitors( ): Observable<Anonyme[]> {
 
        return this.http
            .get<Anonyme[]>(this.exhibitorsUrl + '/findAllExhibitors/' )
            .pipe(
                tap(_ => this.notify('fetched exhibitors', 'GET')),
                catchError(this.handleError('getClients', 'GET'))
            );
    }


    
    /* filterClients(filterClient:FilterClient): Observable<Client[]> {
 //console.log(this.exhibitorsUrl + '/findByUserType');
 
         return this.http
             .put<Client[]>(this.exhibitorsUrl + '/filterClients/',filterClient  )
             .pipe(
                 tap(_ => this.notify('fetched exhibitors', 'GET')),
                 catchError(this.handleError('getClients', 'GET'))
             );
     }*/

    printParticipants(filterClient: FilterClient): any {
        return this.http.put(this.exhibitorsUrl + '/printParticipants', filterClient, { responseType: "blob"});
    }




    /** 
     * GET: get an existing exhibitor from the database by an id 
     */
    getExhibitor(id: number): Observable<Client> {
        const url = `${this.exhibitorsUrl}/${id}`;
        return this.http
            .get<Client>(url)
            .pipe(
                tap(_ => this.notify(`fetched exhibitor id=${id}`, 'GET')),
                catchError(this.handleError(`getClient id=${id}`, 'GET'))
            );
    }

    /*
        findVisaByExhibitor(id: number): Observable<VisaFormTbl[]> {
            const url = `${this.onlineformtblUrl}/findVisaByExhibitor/${id}`;
            return this.http
                .get<VisaFormTbl[]>(url, httpOptions)
                .pipe(tap(_ => this.notify(`fetched exhibitor id=${id}`, 'GET')),
                    catchError(this.handleError(`getClient id=${id}`, 'GET')));
        }
    
        printVisa(type: string, typeInvitation: string, idVisaFormTbl: number): any{
            const url = `${this.onlineformtblUrl}/printInvitationRapatr/${type}/${typeInvitation}/${idVisaFormTbl}`;
            return this.httpPdf
                .get (url, { responseType: ResponseContentType.Blob, headers: this.getHeaders1() }).map(
                    (res) => {
                      return new Blob([res.blob()], { type: 'application/pdf' });
                    });
        }
    */

   archiver(client:Client ): Observable<any> {
  let  filterClient=new FilterClient();
  filterClient.typeClient=client.observation;
  return  this.http.put<Client>(`${this.exhibitorsUrl}/archiver/${client.idClient}`, filterClient)
}
updateChamp(client:Client,champ:String,value:any ): Observable<any> {
    let  filterClient=new FilterClient();
    filterClient.typeClient=client.observation;
    return  this.http.put<Client>(`${this.exhibitorsUrl}/updateChamp/${client.idClient}/${champ}/${value}`, filterClient)
  }
  updateStatus(client:Client,status:string,color:string ): Observable<any> {
    client.prospectId.status=status;
    client.prospectId.color=color;
    return  this.http.put<Prospect>(`${this.exhibitorsUrl}/updateStatus`, client.prospectId)
  }
  

    editRemarque(idExhibitor: number, remarque: string): Observable<any> {
        if (remarque)
            remarque = remarque.replace("/", '');


        return this.http
            .put(`${this.exhibitorsUrl}/editRemarque/${idExhibitor}/${remarque}aa`, httpOptions)
            .pipe(
                tap(_ => this.notify(`updated exhibitor id=${idExhibitor}`, 'PUT')),
                catchError(this.handleError('updateClient', 'PUT'))
            );
    }

    basculer(staff: Staff, idExhibitor: number): Observable<any> {
        return this.http.put<Client>(`${this.exhibitorsUrl}/basculer/${idExhibitor}`, staff);
    }


    editLogistiques(idExhibitor: number): Observable<any> {
        return this.http
            .put(`${this.exhibitorsUrl}/editLogistiques/${idExhibitor}`, httpOptions) ;
    }

    /** 
     * POST: add a new exhibitor to the database 
     */
    addExhibitor(exhibitor: Client): Observable<any> {
         return this.http
            .post<Client>(this.exhibitorsUrl, exhibitor, httpOptions)
            .pipe(
                tap((exhibitor: Client) => this.notify(`added Client w/ id=${exhibitor.idClient}`, 'POST'))
            );
    }

    addExhibitorERP(exhibitor: Client): Observable<any> {
         return this.http
            .post<Client>(this.exhibitorsUrlERP, exhibitor, httpOptions)
            .pipe(
                tap((exhibitor: Client) => this.notify(`added Client w/ id=${exhibitor.idClient}`, 'POST'))
            );
    }

    async  importerClient(exhibitor: Client): Promise<Observable<any>> {
        //console.log("selected Project addExhibitor" + JSON.stringify(exhibitor.projetId));
        return this.http
            .put<Client>( `${this.exhibitorsUrl}/importerClient`, exhibitor,httpOptions )
            .pipe(
                tap((exhibitor: Client) => this.notify(`added Client w/ id=${exhibitor.idClient}`, 'POST'))
            );
    }
    async  importerContacts(contacts:Contact[],exhibitor: Client)  {

  
        return this.http
            .put<Contact[]>( `${this.exhibitorsUrl}/importerContacts/${exhibitor.idClient}`, contacts,httpOptions )
            .pipe( 
                tap((contact: Contact[]) => this.notify(`added Client w/ id=${exhibitor.idClient}`, 'POST'))
               ).toPromise().catch(err=>{
                    
               })
           
    }


  async  confirmExhibitorERP(exhibitor: Client): Promise<Observable<any>> {
        //console.log("selected Project addExhibitor" + JSON.stringify(exhibitor.projetId));
        return this.http
            .put<Client>(this.exhibitorsUrlERP+`/confirmer`, exhibitor,httpOptions )
            .pipe(
                tap((exhibitor: Client) => this.notify(`added Client w/ id=${exhibitor.idClient}`, 'POST'))
            );
    }
    async  confirmContactsERP(contacts:Contact[],exhibitor: Client)  {

  
        return this.http
            .put<Contact[]>( `${this.exhibitorsUrlERP}/confirmerContacts/${exhibitor.idClient}`, contacts,httpOptions )
            .pipe( 
                tap((contact: Contact[]) => this.notify(`added Client w/ id=${exhibitor.idClient}`, 'POST'))
               ).toPromise().catch(err=>{
                    
               })
           
    }




    async  confirmProformaERP(facture:Facture,exhibitor: Client)  {

  
        return this.http
            .put<Contact[]>( `${this.exhibitorsUrlERP}/confirmerFacture/${exhibitor.idClient}`, facture,httpOptions )
            .pipe( 
                tap((contact: Contact[]) => this.notify(`added Client w/ id=${exhibitor.idClient}`, 'POST'))
               ).toPromise().catch(err=>{
                    
               })
           
    }
    async  confirmContactERP(contacts:Contact[],exhibitor: Client)   {

         
        this.http
        .put<Contact>( `${this.exhibitorsUrlERP}/confirmerContact/${exhibitor.idClient}`, contacts[0],httpOptions )
        .pipe( 
         tap((contact: Contact) => this.notify(`added Client w/ id=${exhibitor.idClient}`, 'POST'))
        ).toPromise().catch(err=>{
             
        })
                  
           }
    catchError(err: any): any {
         
    }


    addCoExhibitor(idExhibitor: number, exhibitor: Client): Observable<any> {
        //console.log("selected Project addExhibitor" + JSON.stringify(exhibitor.projetId));
        return this.http
            .post<Client>(this.exhibitorsUrl + '/addCoExhibitor/' + idExhibitor, exhibitor, httpOptions)
            .pipe(
                tap((exhibitor: Client) => this.notify(`added Client w/ id=${exhibitor.idClient}`, 'POST'))
            );
    }
    /** 
     * PUT: update an existing exhibitor to the database 
     */
    /*  updateExhibitor(exhibitor: Client): Observable<any> {
          return this.http
              .put(`${this.exhibitorsUrl}/${exhibitor.idClient}`, exhibitor, httpOptions)
              .pipe(
                  tap(_ => this.notify(`updated exhibitor id=${exhibitor.idClient}`, 'PUT')),
                  catchError(this.handleError('updateClient', 'PUT'))
              );
      }*/

    /** 
     * DELETE: delete an existing hero from the database 
     */
    /* deleteExhibitor(exhibitor: Client | number): Observable<any> {
         const id = typeof exhibitor === 'number' ? exhibitor : exhibitor.idClient;
         const url = `${this.exhibitorsUrl}/${id}`;
         return this.http
             .delete<Client>(url, httpOptions)
             .pipe(
                 tap(_ => this.notify(`deleted exhibitor id=${id}`, 'DELETE')),
                 catchError(this.handleError('deleteClient', 'DELETE'))
             );
     }*/


    printFiche(idClient: number):  Observable<Blob> {
        return this.http.get(this.exhibitorsUrl + '/printFiche/' + idClient, { responseType: "blob"});
    }
    addPjoint(file: FormData, folder: string): Observable<Response> {
        //console.log(` Folder :  ${this.exhibitorsUrl}/addPjoint/${folder}`);

        return this.http.put<Response>(`${this.exhibitorsUrl}/addPjoint/${folder}`, file);
    }
    private getHeaders1() {
        const headers = new Headers();
        headers.append('Accept', 'application/pdf');
        headers.append('Content-Type', 'application/pdf');
        return headers;
    }

    affectContactExhibitor(exhibitorId: number, contactId: number): Observable<any> {
        return this.http
            .put(`${this.exhibitorsUrl}/affectContactExhibitor/${exhibitorId}/${contactId}`, httpOptions)
            .pipe(
                tap(_ => this.notify(`updated contact id=${contactId}`, 'PUT')),
                catchError(this.handleError('updateContact', 'PUT'))
            );
    }
    updateStands(idClient: number, idStand: number, isAdd: boolean): Promise<any> {

        return this.http
            .put(`${this.exhibitorsUrl}/updateStands/${idClient}/${idStand}/${isAdd}`, httpOptions)

            .toPromise()
            .then(_ => this.notify(`updated stand exhibitor id=${idClient}`, 'PUT'))
            .catch(this.handleError('updateStandsClient', 'PUT'));



    }
 
    affectConstructeurClient(idClient: number, idConstructeur: number ): Promise<any> {

        return this.http
            .put(`${this.exhibitorsUrl}/affectConstructeurClient/${idClient}/${idConstructeur}`, httpOptions)

            .toPromise()
            .then(_ => this.notify(`updated stand exhibitor id=${idClient}`, 'PUT'))
            .catch(this.handleError('updateStandsClient', 'PUT'));
 
    }

    
    findClientsConstructeur(idConstructeur: number): Observable<Client[]> {

        return this.http.get<Client[]>(`${this.exhibitorsUrl}/findClientsConstructeur/` + idConstructeur, httpOptions);

    }
    findClientsByRaison(term: string): Observable<Client[]> {

        return this.http.get<Client[]>(`${this.exhibitorsUrl}/findClientsByRaison/` + term, httpOptions);

    }
    findByRaisonTypeUser(raison: string, type: string, userId: number): Observable<Client[]> {

        return this.http.get<Client[]>(`${this.exhibitorsUrl}/findByRaisonTypeUser/${raison}/${type}/${userId}`, httpOptions);

    }

    findConfByRaison(term: string): Observable<Prospect[]> {

        return this.http.get<Prospect[]>(`${this.baseUrl}prospect/findConfByRaison/` + term, httpOptions);

    }
    getPjointsClient(idClient: number): Observable<Pjoint[]> {
        return this.http.get<Pjoint[]>(`${this.exhibitorsUrl}/getPjointsClient/${idClient}`);
    }

    findContacts(IdProspect: number): Observable<Contact[]> {

        const contact$ = this.http
            .get<Contact[]>(this.baseUrl + `prospect/contacts/` + IdProspect, httpOptions);
        return contact$;

    }
    findStandsClient(clientId: number): Observable<Stand[]> {
        return this.http.get<Stand[]>(`${this.exhibitorsUrl}/findStandsClient/${clientId}`);
    }
    findContratClient(clientId: number): Observable<Facture> {
        return this.http.get<Facture>(`${this.exhibitorsUrl}/findContratClient/${clientId}`);
    }

    private subject = new Subject<any>();

    subscribeStandClient(clientId: number) {
        this.findStandsClient(clientId).subscribe(result => {
            this.subject.next(result);
        })



    }




    getSelectedStand(): Observable<any> {
        return this.subject.asObservable();
    }


    private subject1 = new Subject<any>();

    subscribeConstructeurClient(clientId: number) {
        this.findClientsConstructeur(clientId).subscribe(result => {
            this.subject1.next(result);
        })



    }




    getSelectedConstructeur(): Observable<any> {
        return this.subject1.asObservable();
    }

    /**
     * Prepare an error handler for failed HTTP requests.
     * That handler extracts the error message and logs it.
     * It also adds the message to the errors$ observable to which the caller
     * may listen and react.
     * @param operation The name/description of the operation that failed
     * @param method The HTTP method for the failed HTTP request
     */
    protected handleError(operation: string, method: string) {
        return function errorHandler(res: HttpErrorResponse) {
            this.logger.error(res);
            const eMsg = res.message || '';
            const error = `${this.entityNamePlural} ${operation} Error${
                eMsg ? ': ' + eMsg : ''
                }`;
            this.notify(error, method);
        }.bind(this);
    }

    protected notify(message: string, method: string) {

    }
}
